import React, { useEffect, useRef, useState } from "react";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  placeholder: {
    id: "searchBar.placeholder",
    defaultMessage: "Search",
  },
});

export const SearchBarTailwind = ({ data, handleSelectOption }: any) => {
  const intl = useIntl();

  const [isExpanded, setIsExpanded] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const refSearchInput: any = useRef(null);

  const [dataFiltered, setDataFiltered] = useState(data);

  useEffect(() => {
    if (searchInput.length > 1 && isExpanded) {
      const result = data.filter((option: any) =>
        option.label.toLowerCase().includes(searchInput.toLowerCase())
      );

      setDataFiltered(result);

      setOpenDropdown(true);
    } else {
      setOpenDropdown(false);
    }
  }, [data, isExpanded, searchInput]);

  useEffect(() => {
    function handleClickOutside(e: any) {
      if (!refSearchInput.current.contains(e.target)) {
        setTimeout(() => {
          setOpenDropdown(false);
        }, 100);
      }
    }
    document.addEventListener("mousedown", handleClickOutside, true);
    document.addEventListener("scroll", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
      document.removeEventListener("scroll", handleClickOutside, true);
    };
  }, [refSearchInput]);

  return (
    <div className="relative flex items-center" ref={refSearchInput}>
      <svg
        className="w-4 h-4 cursor-pointer mr-[10px]"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => setIsExpanded(!isExpanded)}>
        <path
          d="M12.3219 10.614H11.5813L11.3188 10.3609C12.2375 9.29213 12.7906 7.90463 12.7906 6.39526C12.7906 3.02964 10.0625 0.301514 6.69689 0.301514C3.33127 0.301514 0.603149 3.02964 0.603149 6.39526C0.603149 9.76088 3.33127 12.489 6.69689 12.489C8.20627 12.489 9.59377 11.9359 10.6625 11.0171L10.9156 11.2796V12.0202L15.6031 16.6984L17 15.3015L12.3219 10.614ZM6.69689 10.614C4.36252 10.614 2.47815 8.72963 2.47815 6.39526C2.47815 4.06088 4.36252 2.17651 6.69689 2.17651C9.03127 2.17651 10.9156 4.06088 10.9156 6.39526C10.9156 8.72963 9.03127 10.614 6.69689 10.614Z"
          fill="#2E3862"
        />
      </svg>

      <input
        className={`${
          isExpanded ? "w-40 px-2 py-1" : "w-0"
        }  text-sm rounded-md transition-all duration-1000 focus:outline-none focus:border-blue-500`}
        type="text"
        placeholder={intl.formatMessage(messages.placeholder)}
        onChange={e => setSearchInput(e.target.value)}
      />

      {openDropdown && (
        <div
          id="dropdownNavbar"
          className="z-10 absolute bg-white divide-y divide-gray-100 rounded-lg shadow top-[40px] ml-6 w-48 max-h-[400px] overflow-y-auto z-[9999]">
          <ul className="p-2 text-sm" aria-labelledby="dropdownNavbarButton">
            {dataFiltered.map((item: any) => (
              <div
                key={`${item.value}-${item.label}`}
                className="flex justify-start items-center p-2 hover:bg-gray-100 text-[#5C5C5C] cursor-pointer"
                onClick={() => {
                  handleSelectOption(item.value);
                }}>
                <span className="hover:text-[#2E3862] truncate">
                  <span className="text-[#5C5C5C] pl-2 no-underline">{item.label}</span>
                </span>
              </div>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
